// Lib
import { Action, handleActions } from 'redux-actions';

// Actions
import { UsersSearch, UsersSearchResult } from '@actions/search';

interface User {
  _id: string;
  username?: string;
  [key: string]: unknown;
}

interface UsersSearchState {
  loading: boolean;
  list: User[];
}

interface SearchState {
  users: UsersSearchState;
}

interface UsersSearchResultPayload {
  users: User[];
}

type UsersSearchResultAction = Action<UsersSearchResultPayload>;

const initialState: SearchState = {
  users: {
    loading: false,
    list: [],
  },
};

export default handleActions<SearchState, UsersSearchResultPayload | void>(
  {
    [UsersSearch.toString()]: (state: SearchState): SearchState => ({
      ...state,
      users: {
        ...state.users,
        loading: true,
      },
    }),
    [UsersSearchResult.toString()]: (
      state: SearchState,
      { payload }: UsersSearchResultAction,
    ): SearchState => ({
      ...state,
      users: {
        loading: false,
        list: payload.users,
      },
    }),
  },
  initialState,
);
